import _axios from "../../lawcaseReq.js";

// 文档
// http://sc-docs.tsa.cn/document/swagger-ui/498.html 

//获取律师认证状态 1已通过 2待审批 3已拒绝 4未认证 5驳回
export const getLawyerStatus = () =>
    _axios({
        url: '/lawyer/status',
        method: "get",
        isMessage:false
    });